import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/private/services/client.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { UpdateOrganizationComponent } from "../../client-details/update-organization/update-organization.component";
import { CenterComponent } from "../../client-center/center-details/center-details.component";
import { DepartmentSectionComponent } from "../../department/department-details/department-details.component";
import { RoleDetailsComponent } from "../../roles/role-details/role-details.component";
import { UserSectionComponent } from "../../user-section/user-section.component";
import { EmailConfigComponent } from "../../email-config/email-config/email-config.component";
import { ClientPackageComponent } from 'src/app/private/components/client-package/client-package.component';
import { WhatsappConfigComponent } from "../../whatsapp-config/whatsapp-config/whatsapp-config.component";
import { ActiveDirectoryConfigDetailsComponent } from "../../active-directory-config/active-directory-config-details/active-directory-config-details.component";
import { GoogleConfigDetailsComponent } from "../../google-config/google-config-details/google-config-details.component";
import { CounterComponent } from 'src/app/private/components/counter/counter.component';

@Component({
  selector: 'app-client-details',
  imports: [SharedModule, UpdateOrganizationComponent, CenterComponent, DepartmentSectionComponent, RoleDetailsComponent, UserSectionComponent, EmailConfigComponent, ClientPackageComponent, WhatsappConfigComponent, ActiveDirectoryConfigDetailsComponent, GoogleConfigDetailsComponent, CounterComponent],
  templateUrl: './client-details.component.html',
  styleUrl: './client-details.component.scss'
})
export class ClientDetailsComponent {
  initLoading: boolean = true;
  clientId: string = '';
  clientData: any = null;

  activeTab = 'details';
  statuses = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  tabs = [
    { label: 'Client Details', value: 'details' },
    { label: 'Center', value: 'center' },
    { label: 'Departments', value: 'departments' },
    { label: 'Counter', value: 'counter' },
    { label: 'Roles', value: 'roles' },
    { label: 'Users', value: 'users' },
    { label: 'Email Config', value: 'emailConfig' },
    { label: 'Client Package', value: 'packages' },
    { label: 'Whatsapp Config', value: 'whatsappConfig' },
    { label: 'Active Directory Config', value: 'activeDirectoryConfig' },
    { label: 'Google Config Token', value: 'googleConfig' }
  ];


  constructor(
    private localStorage: LocalStorageService,
    private api: ClientService,
    private router: Router,

  ) {
    this.clientId = this.router.url.split('/').pop() || '';
    this.getClientDetails();
  }

  getClientDetails() {

    const payload = {
      client_id: this.clientId
    }

    this.api.getClient(this.clientId).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.clientData = res.data;
        this.initLoading = false;
      } else {
        this.initLoading = false;
      }
    }, (err) => {
      this.initLoading = false;
    });
  }
}
